// extracted by mini-css-extract-plugin
export default {"trendContainer":"trend_trendContainer__5RARt","trendBody":"trend_trendBody__-k2i4","trendDirection":"trend_trendDirection__eyy2u"};